import React from "react";
import LegalPage from "components/Legal/LegalPage.jsx";

export default function NutzungsbedingungenPage() {
    return (
        <LegalPage title="Nutzungsbedingungen">
            <h2>1. Geltungsbereich</h2>
            <p>Diese Nutzungsbedingungen regeln die Nutzung der Plattform kimat-online.</p>

            <h2>2. Leistungsbeschreibung</h2>
            <p>
                kimat-online stellt Informationen, KI-gestützte Analysen, Signale und
                Auswertungen zu öffentlich zugänglichen Nachrichteninhalten mit möglichem
                Bezug zu Finanzinstrumenten bereit.
            </p>

            <h2>3. Keine Verfügbarkeitsgarantie</h2>
            <p>
                Eine jederzeitige, ununterbrochene und fehlerfreie Verfügbarkeit der
                Plattform wird nicht geschuldet.
            </p>

            <h2>4. Zugangsdaten</h2>
            <p>
                Nutzer sind verpflichtet, ihre Zugangsdaten vertraulich zu behandeln und
                vor unbefugtem Zugriff zu schützen.
            </p>

            <h2>5. Zulässige Nutzung</h2>
            <ul>
                <li>keine missbräuchliche Nutzung</li>
                <li>kein Umgehen technischer Schutzmaßnahmen</li>
                <li>keine Nutzung zu rechtswidrigen Zwecken</li>
                <li>kein unzulässiges massenhaftes Auslesen der Plattform</li>
            </ul>

            <h2>6. KI-generierte Inhalte</h2>
            <p>
                Inhalte, Signale und Bewertungen können automatisiert erzeugt sein. Sie
                können fehlerhaft, unvollständig, verzögert oder missverständlich sein.
            </p>

            <h2>7. Keine Anlageberatung</h2>
            <p>
                Es erfolgt keine Anlageberatung, keine Anlagevermittlung, keine
                Finanzportfolioverwaltung und keine Aufforderung zum Kauf, Verkauf oder
                Halten von Finanzinstrumenten.
            </p>

            <h2>8. Haftung</h2>
            <p>
                Wir haften unbeschränkt bei Vorsatz, grober Fahrlässigkeit sowie bei
                Verletzung von Leben, Körper oder Gesundheit. Im Übrigen haften wir nur
                im Rahmen zwingender gesetzlicher Vorschriften.
            </p>

            <h2>9. Änderungen</h2>
            <p>
                Wir behalten uns vor, Funktionen, Inhalte und diese Nutzungsbedingungen
                für die Zukunft anzupassen.
            </p>

            <h2>10. Anwendbares Recht</h2>
            <p>Es gilt deutsches Recht, soweit gesetzlich zulässig.</p>
        </LegalPage>
    );
}